import React, { useEffect, useState, useRef } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatDate, limitParagraphByCharLimit } from "../../Helper/Helper";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import Spinner from "../Spinner";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

const animationList = ["fadeInLeft", "fadeInRight"];

function TimelineViewBlogsGrid() {
  const timelineSectionRef = useRef(null);
  const sitedata = useSelector((store) => store.global.loginData);
  const [blogsData, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("blogs/list");
      const data = response?.data || [];
      setBlogsData(data);
      setHasData(data.length > 0);
    } catch (error) {
      console.error("Error fetching blogs:", error);
      setBlogsData([]);
      setHasData(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasData) return;

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animatedItems = entry.target.querySelectorAll("li.animated");
          animatedItems.forEach((item, index) => {
            setTimeout(() => {
              const animationType = item.getAttribute("data-animation");
              if (
                animationType === "fadeInLeft" &&
                !item.classList.contains("visible")
              ) {
                item.classList.add("fadeInLeft", "visible");
              } else if (
                animationType === "fadeInRight" &&
                !item.classList.contains("visible")
              ) {
                item.classList.add("fadeInRight", "visible");
              }
            }, index * 300);
          });
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });

    if (timelineSectionRef.current) {
      observer.observe(timelineSectionRef.current);
    }

    return () => {
      if (timelineSectionRef.current) {
        observer.unobserve(timelineSectionRef.current);
      }
    };
  }, [hasData, blogsData]);

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Blogs" Image="theme-2-banner-blog.webp"/>

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <Spinner />
          </div>
        ) : hasData ? (
          <section
            className="timeline-section pad-top-80 pad-bottom-80 full-dark"
            ref={timelineSectionRef}
          >
            <div className="container">
              <div className="row">
                {/* <div className="offset-md-2 col-md-8">
                  <div className="title-wrap text-center">
                    <div className="section-title margin-bottom-60">
                      <h2 className="section-title mb-0 text-uppercase">
                        Our <span className="theme-color">Blogs</span>
                      </h2>
                      <span className="section-border-bottom center"></span>
                    </div>
                  </div>
                </div> */}
                <div className="col-lg-12">
                  <div className="timeline-wrapper">
                    <ul className="timeline">
                      {blogsData.map((blog, index) => (
                        <li
                          key={index}
                          className={`mb-5 animated ${
                            index % 2 === 1 ? "timeline-inverted" : ""
                          }`}
                          data-animation={animationList[index % 2]}
                           style={{ minHeight: "200px" }} 
                        >
                          <div className="timeline-image">
                            <div
                              className="img-circle first-fservices-img-wrapper"
                              style={{
                                backgroundImage: `url(${blog?.image})`,
                              }}
                            />
                          </div>
                          <div className="timeline-panel">
                            <Link to={`/blog/detail/${blog?.slug}`}>
                              <div className="timeline-heading">
                                <h4 className="timeline-title text-uppercase" style={{fontSize:"19px", lineHeight:"28px"}} >
                                  {blog?.title}
                                </h4>
                                <div className="post-date">
                                  <i className="ti-calendar theme-color me-1"></i>
                                  {formatDate(blog?.date)}
                                </div>
                              </div>
                              <div className="timeline-body">
                                <p>
                                  {limitParagraphByCharLimit(
                                    blog?.short_content || blog?.content,
                                    190
                                  )}
                                </p>
                              </div>
                            </Link>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <div className="col-12 text-center my-5 py-5">
            <h4>No Record Available</h4>
          </div>
        )}

        <FooterWrapper />
      </div>
    </div>
  );
}

export default TimelineViewBlogsGrid;